import { postAxiosSingle, deleteAxiosSingle } from '../pages/api/axios'
import { SubscibeURL } from '../constants/url'
import A from './metrics/analytic'
import { AlertSubscriptionText, AlertType, IAlertMessage } from 'constants/alert'

const handleSubscription = async (
  isSubscribed: boolean,
  place: string,
  id: number,
  setSubscribed: (status: boolean) => void,
  setSingleAlert: (singleAlertMessage: IAlertMessage) => void
): Promise<void> => {
  const url = `${SubscibeURL.LECTUR}/${id}`
  A.setLectorSubscription(id, place, isSubscribed)

  if (!isSubscribed) {
    const { status } = await postAxiosSingle(url)
    if (status === 200) setSubscribed(true)
    else
      setSingleAlert({
        type: AlertType.SUB_ERROR,
        text: AlertSubscriptionText[AlertType.SUB_ERROR],
        id: AlertType.SUB_ERROR,
      })
  } else {
    const { status } = await deleteAxiosSingle(url)
    if (status === 200) setSubscribed(false)
  }
}

export { handleSubscription }
